module.exports = __webpack_public_path__ + "9f6ecdbe77059ab675ec6cee35d5366b.png";